const colorCodes = [
 {
    name:"Agate Blue",
    value:"#333a4a"
 },
 {
    name:"Amethyst",
    value:"#9966cc"
 },
 {
    name:"Azure",
    value:"#007FFF"
 },
 {
    name:"Beige",
    value:"#F5F5DC"
 },
 {
    name:"Black",
    value:"#000000"
 },
 {
    name:"Black Floral",
    value:"#AE99D2"
 },
 {
    name:"Black H2O",
    value:"#2e4845"
 },
 {
    name:"Black Springs",
    value:"#177245"
 },
 {
    name:"Blue",
    value:"#0000FF"
 },
 {
    name:"Blue Argyle",
    value:"#348a5d"
 },
 {
    name:"Blue Crackle",
    value:"#1e5473"
 },
 {
    name:"Blue Flame",
    value:"#5ebac9"
 },
 {
    name:"Blue Floral",
    value:"#1d697c"
 },
 {
    name:"Blue Ridge",
    value:"#1d697c"
 },
 {
    name:"Blue Slate Camo",
    value:"#647580"
 },
 {
    name:"Blue Springs",
    value:"#b5bcbd"
 },
 {
    name:"Blue transparent",
    value:"#ddddff"
 },
 {
    name:"Bronze",
    value:"#CD7F32"
 },
 {
    name:"Brown",
    value:"#964B00"
 },
 {
    name:"Burgundy",
    value:"#800020"
 },
 {
    name:"Burgundy Flame",
    value:"#43302e"
 },
 {
    name:"Camo",
    value:"#766D31"
 },
 {
    name:"Camouflage",
    value:"#766D31"
 },
 {
    name:"Castle Red",
    value:"#645d55"
 },
 {
    name:"Champagne",
    value:"#F7E7CE"
 },
 {
    name:"charcoal",
    value:"#36454F"
 },
 {
    name:"Chocolate",
    value:"#D2691E"
 },
 {
    name:"Chrome",
    value:"#4c8bf5"
 },
 {
    name:"Clear",
    value:"#dcf0ef"
 },
 {
    name:"Clear Pouch",
    value:"#dcf0ef"
 },
 {
    name:"Clinical",
    value:"#d4cfc9"
 },
 {
    name:"Cobalt Blue",
    value:"#0047ab"
 },
 {
    name:"Cream",
    value:"#FFFDD0"
 },
 {
    name:"Creme",
    value:"#FFFDD0"
 },
 {
    name:"Dark Blue",
    value:"#00008B"
 },
 {
    name:"Dark Green",
    value:"#006400"
 },
    {
        "name": "Dark Purple",
        "value": "#301934"
    },
    {
        "name": "Dark Red",
        "value": "#8B0000"
    },
    {
        "name": "Designer Blue",
        "value": "#0000FF"
    },
    {
        "name": "Electric Blue",
        "value": "#7DF9FF"
    },
    {
        "name": "Fire Truck Red",
        "value": "#ce2029"
    },
    {
        "name": "Flame Blue",
        "value": "#005e88"
    },
    {
        "name": "Flame Red",
        "value": "#cf352e"
    },
    {
        "name": "Floral",
        "value": "#FFFAF0"
    },
    {
        "name": "Graphic",
        "value": "#FFFFFF"
    },
    {
        "name": "Gray",
        "value": "#808080"
    },
    {
        "name": "Green",
        "value": "#008000"
    },
    {
        "name": "Green Funnel",
        "value": "#60c339"
    },
    {
        "name": "Green Leaves",
        "value": "#2D5A27"
    },
    {
        "name": "Green, opaque",
        "value": "#008000"
    },
    {
        "name": "Green, transparent",
        "value": "#008000"
    },
    {
        "name": "Grey",
        "value": "#808080"
    },
    {
        "name": "H2O",
        "value": "#9FC1D4"
    },
    {
        "name": "Heather Gray",
        "value": "#9aa297"
    },
    {
        "name": "Hot Green",
        "value": "#25ff29"
    },
    {
        "name": "Hot Orange",
        "value": "#FF6E00"
    },
    {
        "name": "Hot Pink",
        "value": "#FF69B4"
    },
    {
        "name": "Hot Red / Black Print",
        "value": "#FF0000"
    },
    {
        "name": "Hunter",
        "value": "#355E3B"
    },
    {
        "name": "Ice Palace",
        "value": "#e2e4d7"
    },
    {
        "name": "Imperial Blue",
        "value": "#002395"
    },
    {
        "name": "Jade",
        "value": "#00A36C"
    },
    {
        "name": "Jet Fighter Blue",
        "value": "#7f8583"
    },
    {
        "name": "Knight Blue",
        "value": "#425C77"
    },
    {
        "name": "Latte",
        "value": "#CCAE88"
    },
    {
        "name": "Lavender",
        "value": "#E6E6FA"
    },
    {
        "name": "Leopard",
        "value": "#d09800"
    },
    {
        "name": "Light Blue",
        "value": "#ADD8E6"
    },
    {
        "name": "Light Brown",
        "value": "#C4A484"
    },
    {
        "name": "Light Green",
        "value": "#90EE90"
    },
    {
        "name": "Light Purple",
        "value": "#CBC3E3"
    },
    {
        "name": "Lilac",
        "value": "#C8A2C8"
    },
    {
        "name": "Lime Green",
        "value": "#32CD32"
    },
    {
        "name": "Mystic Blue",
        "value": "#44a6d1"
    },
    {
        "name": "Natural",
        "value": "#ae4a60"
    },
    {
        "name": "Natursoft",
        "value": "#FFFDD0"
    },
    {
        "name": "Navy",
        "value": "#000080"
    },
    {
        "name": "Navy Blue",
        "value": "#000080"
    },
    {
        "name": "Opaque",
        "value": "#FFFFFF"
    },
    {
        "name": "Opaque Pouch",
        "value": "#FFFFFF"
    },
    {
        "name": "Orange",
        "value": "#FFA500"
    },
    {
        "name": "Orange Funnel",
        "value": "#113366"
    },
    {
        "name": "Orange Springs",
        "value": "#ff6c00"
    },
    {
        "name": "Pastel Blue",
        "value": "#AEC6CF"
    },
    {
        "name": "Pastel Green",
        "value": "#C1E1C1"
    },
    {
        "name": "Pastel Pink",
        "value": "#dea5a4"
    },
    {
        "name": "Pink",
        "value": "#FFC0CB"
    },
    {
        "name": "Pink / White Print",
        "value": "#FFC0CB"
    },
    {
        "name": "Pink Argyle",
        "value": "#dab5a9"
    },
    {
        "name": "Pink Camo",
        "value": "#B04377"
    },
    {
        "name": "Pink Floral",
        "value": "#d772a9"
    },
    {
        "name": "Plaid",
        "value": "#ccdebc"
    },
    {
        "name": "Purple",
        "value": "#800080"
    },
    {
        "name": "Red",
        "value": "#FF0000"
    },
    {
        "name": "Red Crackle",
        "value": "#1e5473"
    },
    {
        "name": "Red Springs",
        "value": "#FF0000"
    },
    {
        "name": "Rose Gold",
        "value": "#b76e79"
    },
    {
        "name": "Rose Quartz",
        "value": "#F7CAC9"
    },
    {
        "name": "Rosewood",
        "value": "#65000b"
    },
    {
        "name": "Royal Blue",
        "value": "#4169E1"
    },
    {
        "name": "Sage",
        "value": "#BCB88A"
    },
    {
        "name": "Sapphire",
        "value": "#0F52BA"
    },
    {
        "name": "Silver",
        "value": "#C0C0C0"
    },
    {
        "name": "Silver Vein",
        "value": "#aaa9ad"
    },
    {
        "name": "Sleek Blue",
        "value": "#ffc3c6"
    },
    {
        "name": "Stars and Stripes",
        "value": "#FF0000"
    },
    {
        "name": "Sterling",
        "value": "#E2E5E6"
    },
    {
        "name": "Stone Blue",
        "value": "#809ca7"
    },
    {
        "name": "Swirl",
        "value": "#d7ccc8"
    },
    {
        "name": "Tan",
        "value": "#D2B48C"
    },
    {
        "name": "Tattoo",
        "value": "#2b4f9c"
    },
    {
        "name": "Teal",
        "value": "#008080"
    },
    {
        "name": "Transparent",
        "value": "#00FFFFFF"
    },
    {
        "name": "Tropical Floral",
        "value": "#c87b9b"
    },
    {
        "name": "Turquoise",
        "value": "#40E0D0"
    },
    {
        "name": "Ultra-Clear",
        "value": "#FFFFFF"
    },
    {
        "name": "Vanilla Cream",
        "value": "#f9e5bc"
    },
    {
        "name": "White",
        "value": "#FFFFFF"
    },
    {
        "name": "White Springs",
        "value": "#f5f5f5"
    },
    {
        "name": "Wisteria Blue",
        "value": "#a9abc9"
    },
    {
        "name": "Wizard Purple",
        "value": "#685078"
    },
    {
        "name": "Yellow",
        "value": "#FFFF00"
    },
    {
        "name": "Yellow Springs",
        "value": "#F7EBC3"
    }
]